import React from "react";
import { useSelector } from "react-redux";

import { Paper, Box, CircularProgress } from "@mui/material";

import { red } from "@mui/material/colors";
import { TypographyLarge } from "../../../../components/customComponent";
import ActivateBreakdown from "./ActivateBreakdown";
import LinkAnnouncement from "./LinkAnnouncement";
import { useTranslation } from "react-i18next";
import { colorStyling } from "../../../../helpers/color";

const BreakdownStatus = () => {
  const { breakdownAnnouncement, loadingAnnouncement: loading } = useSelector(
    (state) => state.bplrtEquip
  );

  const { t } = useTranslation("bplrtEquipment");

  if (loading)
    return (
      <Paper
        elevation={2}
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          size={20}
          thickness={3}
          sx={{ color: colorStyling.primary }}
        />
      </Paper>
    );

  return Object.keys(breakdownAnnouncement).length === 0 ? (
    <Paper
      elevation={2}
      sx={{
        p: 2,
      }}
    >
      <Box sx={{ display: "flex", flexWrap: "nowrap", alignItems: "center" }}>
        <LinkAnnouncement />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <TypographyLarge
            sx={{
              fontWeight: 600,
              color: red[600],
              textTransform: "capitalize",
            }}
          >
            {t("noLinkAnnouncementText")}
          </TypographyLarge>
        </Box>
      </Box>
    </Paper>
  ) : (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <LinkAnnouncement />
      {breakdownAnnouncement?.length === 1 ? (
        <>
          <TypographyLarge sx={{ fontWeight: 600, mx: 2 }}>
            {t("announcementIdLabel") + breakdownAnnouncement[0]?.id}
          </TypographyLarge>

          <TypographyLarge
            sx={{ fontWeight: 600, textTransform: "capitalize", my: 2, mr: 2 }}
          >
            {t("announcementNameLabel") + breakdownAnnouncement[0]?.name}
          </TypographyLarge>
        </>
      ) : (
        <>
          <TypographyLarge
            sx={{ fontWeight: 600, textTransform: "capitalize", my: 2, mr: 2 }}
          >
            {breakdownAnnouncement?.length + " Announcements Linked"}
          </TypographyLarge>
        </>
      )}

      <ActivateBreakdown />
    </Paper>
  );
};

export default BreakdownStatus;
